import React from 'react';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ selectedUserType, onContinue, onSkip }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center px-4">
      <Button
        variant="outline"
        size="lg"
        onClick={onSkip}
        className="w-full sm:w-auto min-w-[160px] md:min-w-[180px]"
      >
        Skip for now
      </Button>
      
      <Button
        variant="default"
        size="lg"
        onClick={onContinue}
        disabled={!selectedUserType}
        iconName="ArrowRight"
        iconPosition="right"
        className="w-full sm:w-auto min-w-[160px] md:min-w-[180px]"
      >
        Continue
      </Button>
    </div>
  );
};

export default ActionButtons;